<!--
 * @Author: LiZhiWei
 * @Date: 2026-06-01 17:26:39
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-06-01 17:42:16
 * @Description:
-->
<template>
  <main>
    <huiguanjia-home-hero :metrics="heroMetrics" @navigate="scrollToSection" />
    <huiguanjia-sections-pain-points-section />
    <huiguanjia-sections-capabilities-section
      :active-capability="activeCapability"
      :current-capability="currentCapability"
      @select="setActiveCapability"
      @keydown="handleCapabilityKeydown"
    />
    <huiguanjia-sections-scenarios-section />
    <huiguanjia-sections-data-section />
    <huiguanjia-sections-values-section />
    <huiguanjia-sections-contact-section
      :contacts="form.contacts"
      :contacts-error="contactsError"
      :phone="form.phone"
      :company="form.company"
      :message="form.message"
      :phone-error="phoneError"
      :company-error="companyError"
      :form-message="formMessage"
      :form-message-type="formMessageType"
      :submitting="isSubmitting"
      @clear-contacts-error="clearContactsError"
      @clear-phone-error="clearPhoneError"
      @clear-company-error="clearCompanyError"
      @update:contacts="form.contacts = $event"
      @update:phone="form.phone = $event"
      @update:company="form.company = $event"
      @update:message="form.message = $event"
      @submit="handleSubmit"
    />
  </main>
</template>

<script setup lang="ts">
  import { heroMetrics } from '~/constants/huiguanjia-home'

  defineOptions({
    name: 'HuiguanjiaHomePage',
  })

  useSeoMeta({
    title: '绘管家物业云平台 - 智慧社区整体解决方案',
    description:
      '绘管家物业云平台为物业企业提供档案、收费、工单、巡检、智能硬件、移动 OA 与数据大屏能力，助力多项目统一管理、服务闭环和经营决策。',
    keywords: '绘管家,绘家科技,物业管理系统,智慧物业,智慧社区,物业收费系统,物业云平台',
    ogTitle: '绘管家物业云平台 - 智慧社区整体解决方案',
    ogDescription: '打通档案、收费、设备、任务、服务与数据决策，让物业管理更简单、更规范、更高效。',
    ogImage: '/assets/img/figma/hero-banner.png',
    ogType: 'website',
  })

  useHead({
    htmlAttrs: { lang: 'zh-CN' },
    link: [
      { rel: 'icon', href: '/favicon.png', type: 'image/png' },
      { rel: 'apple-touch-icon', href: '/assets/img/huiguanjia-app-icon.png' },
    ],
  })

  const {
    activeCapability,
    clearCompanyError,
    clearContactsError,
    clearPhoneError,
    companyError,
    contactsError,
    currentCapability,
    form,
    formMessage,
    formMessageType,
    handleCapabilityKeydown,
    handleSubmit,
    phoneError,
    scrollToSection,
    setActiveCapability,
    isSubmitting,
  } = useHuiguanjiaHomeContext()
</script>
